/**
 * NOT IN USE, DELETE IN THE FUTURE
 */

import { BundleTreeTypes, SectionsTreeNode } from '../types';

export const findFullNodePathToNodeById = (
  id: string,
  tree: SectionsTreeNode[],
  path: SectionsTreeNode[] = []
): SectionsTreeNode[] | null => {
  for (const node of tree) {
    const currentPath = [...path, node];
    if (node.id === id) return currentPath;
    if (node.children) {
      const result = findFullNodePathToNodeById(id, node.children, currentPath);
      if (result) return result;
    }
  }
  return null;
};

export interface ParentNodeInfo {
  provider?: { node: SectionsTreeNode | null; level: number };
  category?: { node: SectionsTreeNode | null; level: number };
  subcategory?: { node: SectionsTreeNode | null; level: number };
  cluster?: { node: SectionsTreeNode | null; level: number };
  originalPath: SectionsTreeNode[] | null;
}

export const getAllParentNodesByNodeId = (nodeId: string, tree: SectionsTreeNode[]): ParentNodeInfo => {
  const path = findFullNodePathToNodeById(nodeId, tree);
  const parentNodes: ParentNodeInfo = {
    originalPath: path
  };

  if (path && path.length > 1) {
    // The path includes the target node itself, so we start from the parent
    for (let i = 0; i < path.length - 1; i++) {
      const currentNode = path[i];
      switch (currentNode.type) {
        case BundleTreeTypes.PROVIDER:
          parentNodes.provider = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.CATEGORY:
          parentNodes.category = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.SUB_CATEGORY:
          parentNodes.subcategory = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.CLUSTER:
          parentNodes.cluster = { node: currentNode, level: i };
          break;
        // The ‘document’ node is not included here
      }
    }
  }

  return parentNodes;
};
